<!--<div class="row">
     <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'N&deg; protocollo'"
          [valueInput]="ctxBodyFascicolo.fascicolo.numeroProtocollo ? ctxBodyFascicolo.fascicolo.numeroProtocollo : ''">
     </div>
     <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'date'" [labelInput]="'Data protocollazione'"
          [valueInput]="ctxBodyFascicolo.fascicolo.dataProtocollazione ? ctxBodyFascicolo.fascicolo.dataProtocollazione : ''">
     </div>
</div>-->

<!--<div class="row">
  <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
       [labelInput]="'Integrato'"
       [valueInput]="ctxBodyFascicolo.fascicolo.integrato ? 'Si' : 'No'"></div>
  <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'date'"
       [labelInput]="'Data integrazione'"
       [valueInput]="ctxBodyFascicolo.fascicolo.dataIntegrazione ? ctxBodyFascicolo.fascicolo.dataIntegrazione : ''"></div>
</div>-->

<div class="row">
     <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Deliberato'"
          [valueInput]="ctxBodyFascicolo.fascicolo.esitoDefinitivo ? 'Si' : 'No'"></div>
     <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'N&deg; delibera'"
          [valueInput]="ctxBodyFascicolo.fascicolo.numeroDelibera ? ctxBodyFascicolo.fascicolo.numeroDelibera : ''">
     </div>
     <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'" [labelInput]="'Data delibera'"
          [valueInput]="ctxBodyFascicolo.fascicolo.dataDelibera ? ctxBodyFascicolo.fascicolo.dataDelibera : ''"></div>
</div>

<div class="row">
     <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Oggetto ricorso'"
          [valueInput]="ctxBodyFascicolo.fascicolo.oggettoRicorso ? ctxBodyFascicolo.fascicolo.oggettoRicorso.label : ''">
     </div>
     <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'N&deg; provvedimento impugnato'"
          [valueInput]="ctxBodyFascicolo.fascicolo.numeroProvvedimento ? ctxBodyFascicolo.fascicolo.numeroProvvedimento : ''">
     </div>
     <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'" [labelInput]="'Data provvedimento impugnato'"
          [valueInput]="ctxBodyFascicolo.fascicolo.dataProvvedimento ? ctxBodyFascicolo.fascicolo.dataProvvedimento : ''">
     </div>
     <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Organo'"
          [valueInput]="ctxBodyFascicolo.fascicolo.organoCompetente ? ctxBodyFascicolo.fascicolo.organoCompetente.label : ''">
     </div>
</div>
<!--<div class="row">
     <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'N&deg; Giunta Esecutiva'"
          [valueInput]="ctxBodyFascicolo.fascicolo.numeroGiuntaEsecutiva ? ctxBodyFascicolo.fascicolo.numeroGiuntaEsecutiva : ''">
     </div>
     <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'date'" [labelInput]="'Data Giunta Esecutiva'"
          [valueInput]="ctxBodyFascicolo.fascicolo.dataGiuntaEsecutiva ? ctxBodyFascicolo.fascicolo.dataGiuntaEsecutiva : ''">
     </div>
</div>-->

<div class="row">
     <div class="col-sm-12 bloccodati">
          <p>
               <label class="col-sm-12">Note</label>
               <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
          </p>
     </div>
</div>